import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const First500Success = lazy(() => import("@/pages/First500Success"));

export const Route = createFileRoute("/first-500/success")({
  component: First500Success,
});
